The type of the component.

Currently, two codes are defined:

- `PrivacyConsent` corresponds to the `privacyConsent` field.
- `Question` corresponds to the `question` and `libraryQuestion` fields.
